export enum WorkOrderType {
  ACTIVITY = 'ACTIVITY',
  SERVICE = 'SERVICE',
  USER = 'USER',
  MANUAL = 'MANUAL'
}
